import React, { forwardRef } from 'react';

interface ContactButtonProps {
  highlight: boolean;
  selected: string;
  contactlink: string;
  title: string;
}

export const ContactButton = forwardRef<HTMLAnchorElement, ContactButtonProps>(
  ({ highlight, selected, contactlink, title }, ref) => {
    const classes =
      window.pageType === 'ContactUsPage' && !highlight
        ? 'c-header-main-menu-item active'
        : 'c-header-main-menu-item';

    if (selected) {
      document.cookie = 'contactcaptcha=true; path=/';
    } else {
      document.cookie = 'contactcaptcha=false; path=/';
    }

    const handleClick = () => {
      window.localStorage.setItem('menuContainerLink', '');
    };

    return (
      <a
        ref={ref}
        onClick={handleClick}
        className={classes}
        href={contactlink}
        id='header-contactbtn'
      >
        {title}
      </a>
    );
  }
);
